import { api } from './api';
import type { TaskType } from '@/types';

export interface ActivityEstimate {
  projectActivityId: number;
  taskTypeId: number;
  activityName: string;
  estimatedHours: number;
  isAvailable: boolean;
}

export interface MemberEstimates {
  projectMemberId: number;
  employeeId: number;
  employeeName: string;
  isActive: boolean;
  estimatedHours: number | null;
  updatedAt: string;
  activityEstimates: ActivityEstimate[];
}

export interface ProjectEstimates {
  projectId: number;
  budgetHours: number | null;
  totalEstimatedHours: number;
  updatedAt: string;
  members: MemberEstimates[];
}

export interface UpdateProjectEstimates {
  expectedUpdatedAt: string;
  members: {
    projectMemberId: number;
    expectedUpdatedAt: string;
    activityEstimates: { taskTypeId: number; estimatedHours: number }[];
  }[];
  budgetHours?: number;
}

export const projectEstimatesService = {
  async get(projectId: number) {
    const [estimates, activities, taskTypes] = await Promise.all([
      api.get<ProjectEstimates>(`/api/Projects/${projectId}/activity-estimates`),
      api.get<number[]>(`/api/Projects/${projectId}/activities`),
      api.get<TaskType[]>('/api/TaskTypes', { includeInactive: true }),
    ]);
    if (!estimates.data || !activities.data || !taskTypes.data) {
      throw new Error('De projectramingen konden niet volledig worden geladen.');
    }
    return { estimates: estimates.data, activityIds: activities.data, taskTypes: taskTypes.data };
  },
  async update(projectId: number, request: UpdateProjectEstimates) {
    const response = await api.put<ProjectEstimates>(`/api/Projects/${projectId}/activity-estimates`, request);
    if (!response.success || !response.data) throw new Error(response.message || 'Opslaan mislukt.');
    return response.data;
  },
};
